import { Link } from 'react-router-dom';
import Reveal from '@/components/feature/Reveal';
import SectionHeader from './SectionHeader';

const systems = [
  'SAP Business One',
  'ERP',
  'WMS',
  'CRM',
  'E-commerce',
  'Payments',
  'Databases',
  'Custom APIs',
];

const sapSkills = [
  'Service Layer',
  'DI API',
  'SAP HANA',
  'SQL Server',
  'AddOns',
  'Integraciones externas',
  'Automatización',
  'APIs',
  'Integraciones B2B',
];

export default function ErpSection() {
  return (
    <section className="relative py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeader
          eyebrow="Integraciones ERP"
          title="Conectamos la IA con el corazón de tu empresa."
          subtitle="Una IA aislada puede responder preguntas. Una IA conectada a tus sistemas puede trabajar. En ACOMA diseñamos integraciones que conectan agentes, aplicaciones y automatizaciones con sistemas empresariales reales."
        />

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-5 gap-8 items-start">
          {/* Diagram */}
          <Reveal className="lg:col-span-3">
            <div className="rounded-lg border border-background-700/60 bg-background-900/50 p-8">
              <div className="flex flex-col items-center">
                <div className="w-52 h-14 rounded-lg bg-gradient-to-br from-primary-500 to-accent-500 flex items-center justify-center glow-primary">
                  <span className="text-white font-bold font-heading tracking-widest">
                    ACOMA AI
                  </span>
                </div>
                <div className="h-10 w-px bg-gradient-to-b from-primary-500/70 to-secondary-500/70 data-flow"></div>
                <div className="w-60 h-12 rounded-lg bg-background-800 border border-secondary-500/40 flex items-center justify-center">
                  <span className="text-secondary-300 text-sm font-medium">
                    Integration Layer
                  </span>
                </div>
                <div className="h-8 w-px bg-gradient-to-b from-secondary-500/70 to-primary-500/70 data-flow"></div>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-3 w-full mt-2">
                  {systems.map((s) => (
                    <div
                      key={s}
                      className="rounded-md bg-background-800/70 border border-background-700/60 px-3 py-3 text-center text-xs md:text-sm text-foreground-500 hover:border-primary-500/40 hover:text-foreground-900 transition-colors"
                    >
                      {s}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Reveal>

          {/* SAP highlight */}
          <Reveal className="lg:col-span-2" delay={120}>
            <div className="rounded-lg border border-primary-500/30 bg-gradient-to-b from-primary-500/10 to-transparent p-7">
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-500/15 border border-primary-500/30 text-primary-300">
                  <i className="ri-stack-line text-xl"></i>
                </div>
                <h3 className="text-lg font-bold font-heading text-foreground-950">
                  SAP Business One
                </h3>
              </div>
              <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
                Experiencia en integraciones SAP Business One con Service Layer,
                DI API, HANA y SQL Server.
              </p>
              <ul className="mt-5 grid grid-cols-2 gap-2.5">
                {sapSkills.map((s) => (
                  <li
                    key={s}
                    className="flex items-start gap-2 text-sm text-foreground-400"
                  >
                    <i className="ri-check-line text-primary-400 mt-0.5"></i>
                    {s}
                  </li>
                ))}
              </ul>
              <Link
                to="/sap-business-one"
                className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-primary-300 hover:text-primary-200 transition-colors cursor-pointer whitespace-nowrap"
              >
                Ver experiencia SAP
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}